"use client";
import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "src/components/common/breadcrumb";
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "src/components/features/loader";
import { Link, useNavigate } from "react-router-dom";
import { capitalize } from "lodash";
import PtSwitch from "src/components/features/elements/switch";
import Pagination from "src/components/common/Pagination";
import AddProduct from "../popups/AddProduct";
import EditProduct from "../popups/EditProduct";
import ConfirmationPopup from "src/components/common/Popups/ConfirmationPopup";
import {
  useDeleteProduct,
  useGetAllRequestediProducts,
  useUpdateProductStatus,
} from "src/services/product.service";
import { generateFilePath } from "src/services/url.service";
import { Product } from "../ProductsList";
import { capitalCase } from "capital-case";

const RequestedProductsPage = () => {
  const navigate = useNavigate();
  //STATE
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<number>(10);
  const [search, setSearch] = useState<string>("");
  const [addProductOpen, setAddProductOpen] = useState<boolean>(false);
  const [isEditOpen, setEditOpen] = useState<boolean>(false);
  const [isDeleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [selectedProductId, setSelectedProductId] = useState<string>("");

  //USE MEMO
  const queryObj = useMemo(() => {
    const obj: any = {
      skip: true,
    };

    if (page) {
      obj.page = page;
    }

    if (limit) {
      obj.limit = limit;
    }

    if (search) {
      obj.search = search;
    }

    return obj;
  }, [page, limit, search]);

  // QUERIES
  const {
    data: products,
    isLoading: isProductsLoading,
    error,
  }: any = useGetAllRequestediProducts({ query: queryObj, enabled: true });

  // MUTATIONS
  const { mutateAsync: updateProductStatus } = useUpdateProductStatus();
  const { mutateAsync: deleteProduct } = useDeleteProduct();

  console.log("products = ", products);

  const handlestatusChange = async (id: string, status: boolean) => {
    try {
      if (id) {
        const res = await updateProductStatus({ id, status });
        if (res) {
          toast(res?.data?.message, {
            containerId: "default",
            className: "no-icon notification-success",
          });
        }
      }
    } catch (error: any) {
      console.log("error status updation :", error);
      toast(
        error?.response?.data?.message ||
        "Something went wrong while updating the status.",
        {
          containerId: "default",
          className: "no-icon notification-danger",
        }
      );
    }
  };

  const handleDeleteProduct = async () => {
    try {
      if (selectedProductId) {
        const res = await deleteProduct(selectedProductId);
        if (res) {
          toast(res?.data?.message, {
            containerId: "default",
            className: "no-icon notification-success",
          });
          setDeleteOpen(false);
        }
      } else {
        toast("Product ID is missing. Unable to delete the product.", {
          containerId: "default",
          className: "no-icon notification-danger",
        });
      }
    } catch (error: any) {
      console.log("error deleting product :", error);
      toast(
        error?.response?.data?.message ||
        "Something went wrong while deleting the product.",
        {
          containerId: "default",
          className: "no-icon notification-danger",
        }
      );
    }
  };

  return (
    <>
      <Breadcrumb
        current={"Requested Products"}
        paths={[
          {
            name: "Dashboard",
            url: "/dashboard",
          },

        ]}
      />
      {/* <Tabs className="nav-tabs  nav-justified">
        <Tab eventKey="approved" title="Approved" className="nav-item"></Tab>
        <Tab eventKey="pending" title="Pending" className="nav-item"></Tab>
        <Tab eventKey="rejected" title="Rejected" className="nav-item"></Tab>
      </Tabs> */}
      <Card>
        <Card.Body className="bg-white">
          <div className="">
            <Row>
              <Col>
                {/* <Card className="card-modern"> */}
                {/* <Card.Body> */}
                <div className="datatables-header-footer-wrapper">
                  <div className="datatable-header">
                    <Row className="align-items-lg-center justify-content-between mb-3">
                      {/* <Col
                        lg="auto"
                        className="mb-2 mb-lg-0 ml-xl-auto pl-xl-1"
                      >
                        <div className="d-flex align-items-lg-center flex-wrap">
                          <Form.Label className="d-none d-xl-block ws-nowrap mr-3 mb-0">Filter By:</Form.Label>
                          <Form.Control
                            as="select"
                            className="select-style-1 filter-by w-auto my-1 mr-2"
                            // value={role}
                            // onChange={(e) => setRole(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value="">Football</option>
                            <option value="">Cricket</option>
                          </Form.Control>
                          <Button
                            type="submit"
                            className="filter-btn my-1"
                            variant="primary"
                          >
                            Filter
                          </Button>
                        </div>
                      </Col> */}
                      <Col className="col-auto pl-lg-2">
                        <div className="search search-style-1 mx-lg-auto w-auto">
                          <InputGroup>
                            <Form.Control
                              type="text"
                              className="search-term"
                              placeholder="Search Product "
                              style={{ width: "250px" }}
                              value={search}
                              onChange={(e) =>
                                setSearch && setSearch(e.target.value)
                              }
                            />
                            {/* <InputGroup.Append> */}
                            {/* <Button
                              variant="default"
                              type="submit"
                            >
                              <i className="bx bx-search"></i>
                            </Button> */}
                            {/* </InputGroup.Append> */}
                          </InputGroup>
                        </div>
                      </Col>
                      <Col xl="auto" className="mb-2 mt-1 mb-xl-0">
                        {/* <Button
                          className="font-weight-semibold"
                          variant="dark"
                          //   size="md"
                          onClick={() => setAddProductOpen(true)}
                        >
                          + Add Product
                        </Button> */}
                      </Col>
                    </Row>
                  </div>
                  <Table
                    className="table-ecommerce-simple mb-0"
                    responsive="xl"
                    striped
                    // bordered
                    style={{ minWidth: "600px" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "30px" }}>#</th>
                        <th
                          // className="text-center"
                          style={{ width: "80px" }}
                        >
                          Product
                        </th>
                        <th></th>
                        <th>Vendor</th>
                        <th>Brand</th>
                        <th>Origin</th>
                        <th>Year</th>

                        <th>Verification</th>
                        <th>Status</th>
                        <th className="text-center" style={{ width: "80px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isProductsLoading ? (
                        <tr>
                          <td colSpan={9}>
                            <Loader />
                          </td>
                        </tr>
                      ) : !isProductsLoading && products?.result?.length > 0 ? (
                        products?.result?.map(
                          (item: any, index: number) => (
                            <tr key={index}


                            >
                              <td>
                                {/* <Link to={`/products/detail?_id=${item?._id}`}> */}
                                {/* <strong> */}
                                {/* {index +
                                  (productsData?.pagination?.page - 1) *
                                    productsData?.pagination?.limit +
                                  1} */}
                                {/* {index + 1} */}
                                {(products?.currentPage - 1) * limit + index + 1}

                                {/* </strong> */}
                                {/* </Link> */}
                              </td>
                              <td>
                                {/* <Link
                                  style={{ width: "50px", height: "50px" }}
                                  className="d-flex align-items-center justify-content-center"
                                  to={`/products/detail?_id=${item?._id}`}
                                > */}
                                <img
                                  className="mr-1"
                                  src={generateFilePath(item?.imageUrl[0])}
                                  // src={item?.imageUrl[0]}
                                  alt="product"
                                  width="40"
                                  height="40"
                                // crossOrigin="anonymous"
                                />
                                {/* </Link> */}
                              </td>
                              <td>
                                <Link to={`/requested-products/details?_id=${item?._id}`}
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  <strong>
                                    {item?.productName} -{" "}
                                    {`${item?.width}${item?.height ? `/${item.height}` : ""
                                      } R${item?.size}`}
                                  </strong>
                                </Link>
                              </td>
                              <td>
                                <Link
                                  to={`/vendors/detail?_id=${item?.created?.createdBy}`}
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {item?.created?.business_name}
                                </Link>
                              </td>
                              <td>
                                <Link
                                  to={`/brands/detail?_id=${item?.brand?._id}`}
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {item?.brand?.name}
                                </Link>
                              </td>


                              {/* <td>{item?.category}</td> */}
                              <td>
                                <Link to={`/attributes/origin`}
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {item?.originDetails?.origin?.value}
                                </Link>
                              </td>
                              <td>
                                <Link to={`/attributes/year_of_manufacture`}
                                  style={{ textDecoration: "none", color: "inherit" }}
                                >
                                  {
                                    item?.yearOfManufacturerDetails
                                      ?.yearOfManufacturer?.value
                                  }
                                </Link>
                              </td>
                              <td>
                                <div
                                  className={`ecommerce-status ${item?.isVerified}`}
                                >
                                  {item?.isVerified
                                    ? capitalCase(item?.isVerified)
                                    : ""}
                                </div>
                              </td>
                              <td>
                                <div
                                  className="d-flex align-items-center"
                                  onClick={() => {
                                    handlestatusChange(
                                      item?._id,
                                      !item?.isSuspend
                                    );
                                  }}
                                >
                                  <PtSwitch
                                    className="mr-2"
                                    on={!item?.isSuspend}
                                    size="sm"
                                    variant="success"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center justify-content-around">
                                  <div
                                    className="action_btn"

                                    onClick={() => {
                                      navigate(`/requested-products/details?_id=${item?._id}`)
                                    }}
                                  >
                                    <i className="far fa-eye"></i>
                                  </div>
                                  {/* <div
                                    className="action_btn"
                                    onClick={() => {
                                      setSelectedProductId(item?._id);
                                      setDeleteOpen(true);
                                    }}
                                  >
                                    <i className="far fa-trash-alt"></i>
                                  </div> */}
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan={9}
                            style={{ textAlign: "center", height: "100px" }}
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                <Pagination
                  currentPage={page}
                  setCurrentPage={setPage}
                  totalButtonsToShow={3}
                  totalPages={products ? products?.totalPages : 1}
                  style={{ marginTop: "20px" }}
                />
                {/* </Card.Body>
            </Card> */}
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>

      <AddProduct
        isOpen={addProductOpen}
        toggle={() => setAddProductOpen(!addProductOpen)}
      />
      <EditProduct
        productId={selectedProductId}
        isOpen={isEditOpen}
        toggle={() => setEditOpen(!isEditOpen)}
      />

      <ConfirmationPopup
        submit={() => handleDeleteProduct()}
        isOpen={isDeleteOpen}
        toggle={() => setDeleteOpen(!isDeleteOpen)}
        text={"Are you sure that you want to delete this product?"}
      />
    </>
  );
};

export default RequestedProductsPage;
